import { Dispatcherb76d0p5pxiow as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatcher2xvjdz9qh940 as Dispatcher_12 } from '../../../../../Coupling-sdk/com/zegreatrob/coupling/sdk/gql/GqlQuery.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_14 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientDispatcherClass;
function ClientDispatcher() {
  if (ClientDispatcherClass === VOID) {
    class $ {
      constructor(sdkDispatcher) {
        this.k7c_1 = sdkDispatcher;
      }
      *z2g(command, $completion) {
        return yield* this.k7c_1.z2g(command, $completion);
      }
      *v2i(command, $completion) {
        return yield* this.k7c_1.v2i(command, $completion);
      }
      *r2h(command, $completion) {
        return yield* this.k7c_1.r2h(command, $completion);
      }
      *a2i(command, $completion) {
        return yield* this.k7c_1.a2i(command, $completion);
      }
      *j2i(command, $completion) {
        return yield* this.k7c_1.j2i(command, $completion);
      }
      *p2i(command, $completion) {
        return yield* this.k7c_1.p2i(command, $completion);
      }
      *y2i(command, $completion) {
        return yield* this.k7c_1.y2i(command, $completion);
      }
      *c2h(command, $completion) {
        return yield* this.k7c_1.c2h(command, $completion);
      }
      *f2h(command, $completion) {
        return yield* this.k7c_1.f2h(command, $completion);
      }
      *s6q(query, $completion) {
        return yield* this.k7c_1.s6q(query, $completion);
      }
      *x2h(command, $completion) {
        return yield* this.k7c_1.x2h(command, $completion);
      }
      *d2i(command, $completion) {
        return yield* this.k7c_1.d2i(command, $completion);
      }
      *m2i(command, $completion) {
        return yield* this.k7c_1.m2i(command, $completion);
      }
      *s2i(command, $completion) {
        return yield* this.k7c_1.s2i(command, $completion);
      }
      *g2i(command, $completion) {
        return yield* this.k7c_1.g2i(command, $completion);
      }
      *i2h(command, $completion) {
        return yield* this.k7c_1.i2h(command, $completion);
      }
    }
    initMetadataForClass($, 'ClientDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13(), Dispatcher_14()], [1]);
    ClientDispatcherClass = $;
  }
  return ClientDispatcherClass;
}
//region block: exports
export {
  ClientDispatcher as ClientDispatcher1p2vginamq4dq,
};
//endregion

//# sourceMappingURL=ClientDispatcher.mjs.map
